import { lazy } from 'react';

const ReportPZ04List = lazy(() =>
  import('../../components/pages/ReportPZ04List/ReportPZ04List'),
);
const AddReportPZ04 = lazy(() =>
  import('../../components/pages/AddReportPZ04/AddReportPZ04'),
);
const EditReportPZ04 = lazy(() =>
  import('../../components/pages/EditReportPZ04/EditReportPZ04'),
);
const DetailsPZ04 = lazy(() =>
  import('../../components/pages/DetailsPZ04/DetailsPZ04'),
);

export const pz04Routes = [
  {
    path: '/pz04',
    permission: 'pz04.list',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER', 'ROZLEW', 'LABO'],
    Component: ReportPZ04List,
  },
  {
    path: '/add-pz04',
    permission: 'pz04.create',
    access: 'authenticated',
    roles: ['ADMIN', 'LABO'],
    Component: AddReportPZ04,
  },
  {
    path: '/edit-pz04/:id',
    permission: 'pz04.edit',
    access: 'authenticated',
    roles: ['ADMIN', 'LABO'],
    Component: EditReportPZ04,
  },
  {
    path: '/details-pz04/:id',
    permission: 'pz04.view',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER', 'KIER_DS_REKLAMACJI', 'LABO'],
    Component: DetailsPZ04,
  },
];
